<template>
  <div>
    <v-select
      :items="estados"
      label="Estado"
      item-text="nome"
      item-value="id"
      v-model="estadoSelecionado"
    />
    <FiltroCidade
      v-if="showCidades"
      :estado="estadoSelecionado"
      @cidade-selecionada="selecionarCidade"
    />
  </div>
</template>

<script>
import api from '../../api'
import FiltroCidade from './FiltroCidade'

export default {
  name: 'FiltroEstadoCidade',
  components: {
    FiltroCidade
  },
  data() {
    return {
      estados: [
        {
          nome: 'Todos os Estados',
          id: null
        }
      ],
      estadoSelecionado: null,
      cidadeSelecionada: null
    }
  },
  computed: {
    showCidades() {
      return this.estadoSelecionado !== null
    }
  },
  watch: {
    estadoSelecionado() {
      this.cidadeSelecionada = null
      this.filtrarEstadoCidade()
    },
    cidadeSelecionada() {
      this.filtrarEstadoCidade()
    }
  },
  async mounted() {
    let estados;
    try {
      const response = await api.post('/', { 
        query: '{ estados { id nome } }' 
      })
      estados = response.data.data.estados
    }
    catch {
      estados = []
    }
    finally {
      this.estados = this.estados.concat(estados)
    }
  },
  methods: {
    selecionarCidade(value) {
      this.cidadeSelecionada = value
    },
    filtrarEstadoCidade() {
      this.$emit('filtrar-estado-cidade', {
        cidade: this.cidadeSelecionada,
        estado: this.estadoSelecionado
      })
    }
  }
}
</script>
